export const ALERT_MESSAGES = {

    ARE_YOU_SURE: 'Are you sure?',

    YES: 'Yes',

    NO: 'No',

    CANCEL: 'Cancel',

};



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/alerts/alert-messages.ts